import { colors, s4 } from '@ardoq/design-tokens';
import { TableList, TableListItem } from '@ardoq/list';
import {
  APIEntityType,
  APIReferenceAttributes,
  ViewpointDetailEntry,
} from '@ardoq/api-types';
import { toByIdDictionary } from '@ardoq/common-helpers';
import { EnhancedScopeData } from '@ardoq/data-model';
import {
  FieldType,
  ReferenceRenderer,
  RenderOption,
  RenderOptions,
  getFieldLabel,
} from '@ardoq/renderers';
import styled from 'styled-components';
import { ColorBar } from '@ardoq/page-layout';
import { getDetailsData } from '../utils';
import { FlexBox } from '@ardoq/layout';

const renderOptions: RenderOptions = {
  definitions: {
    [RenderOption.MARKDOWN]: {
      renderMarkdownInline: true,
    },
  },
  types: {
    [FieldType.TEXT_AREA]: new Set([RenderOption.MARKDOWN]),
  },
};

const StyledColorBar = styled(ColorBar)`
  margin: 0;
`;

type ReferenceAttributesTableProps = {
  reference: APIReferenceAttributes;
  referenceTypeName?: string;
  scopeData: EnhancedScopeData;
  detailEntries?: ViewpointDetailEntry[];
};

const ReferenceAttributesTable = ({
  reference,
  referenceTypeName,
  scopeData,
  detailEntries,
}: ReferenceAttributesTableProps) => {
  const { detailNames, enhancedScopeData } = getDetailsData({
    scopeData,
    entity: reference,
    entityTypeName: referenceTypeName,
    detailEntries,
    fieldFilter: 'all',
  });

  return (
    <FlexBox width="full" padding="medium" gap="medium">
      <StyledColorBar $barColor={colors.borderSubtle} />
      <TableList style={{ margin: `${s4} 0` }}>
        <tbody>
          {detailNames.map(fieldName => {
            const label = getFieldLabel({
              fieldName,
              enhancedScopeData,
              entityType: APIEntityType.REFERENCE,
            });
            return (
              <TableListItem key={fieldName} label={label}>
                <ReferenceRenderer
                  entityId={reference._id}
                  fieldName={fieldName}
                  enhancedScopeData={enhancedScopeData}
                  users={toByIdDictionary(enhancedScopeData.users)}
                  options={renderOptions}
                />
              </TableListItem>
            );
          })}
        </tbody>
      </TableList>
    </FlexBox>
  );
};

export { ReferenceAttributesTable };
